export class InvoiceDetailProjectAppointmentListPresenter extends Array {
  constructor(result) {
    const {
      appointment_list: appointmentList
    } = result;

    const mapped = appointmentList.data.map(project => ({
      id: project.project_id,
      name: project.project_name,
      months: project.date_groups.map(month => ({
        fulfilledAtThaiDateText: month.fulfilled_at_thai_date,
        fulfilledYearMonth: month.fulfilled_year_month,
        homes: month.homes.map(home => ({
          id: home.home_id,
          addressNo: home.address_no,
          appointments: home.appointments.map(appointment => ({
            id: appointment.appointment_id,
            serviceName: appointment.service_name,
          }))
        }))
      }))
    }));

    super(...mapped);
  }
}
